import React, { memo } from "react";
import { useTile } from "./index.hooks";
import { Box } from "@mui/material";

type TileProps = {
  index: number;
};

export const Tile = memo(({ index }: TileProps) => {
  const { onTileClicked, imgPath, cursor, transform } = useTile(index);

  return (
    <Box
      onClick={onTileClicked}
      sx={{
        cursor,
        border: "1px solid #707070",
        lineHeight: 0,
        width: "100%",
        aspectRatio: "1/1",
        transition: "transform 0.3s",
        transform,
      }}
    >
      <img
        style={{
          width: "100%",
          aspectRatio: "1/1",
          margin: "auto",
        }}
        src={imgPath}
        alt="Game tile"
      />
    </Box>
  );
});
